import { render, staticRenderFns } from "./DischargeComponent.vue?vue&type=template&id=56a8cf1b&scoped=true"
import script from "./DischargeComponent.js?vue&type=script&lang=js&external"
export * from "./DischargeComponent.js?vue&type=script&lang=js&external"
import style0 from "./DischargeComponent.vue?vue&type=style&index=0&id=56a8cf1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a8cf1b",
  null
  
)

export default component.exports